/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

document.addEventListener("zrx-slider-item-added", function (e) {
  document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
    bubbles: true
  }));
});

function animateTitle(newTitle) {
  let currentState = false;
  origTitle = 'שרשראות של לאבי במבחר היסטרי';  // save original title
  animatedTitle = newTitle
  timer = setInterval(startAnimation, 2000);

  function startAnimation() {
    // animate between the original and the new title
    document.title = currentState ? origTitle : animatedTitle;
    currentState = !currentState;
  }
}

const necklace_length_input = document.querySelector('#necklace_length')
const variant_options = document.querySelectorAll('.variant-btn')

if(variant_options[0] != null) {
	necklace_length_input.value = variant_options[0].innerText;
}

variant_options.forEach(item => {
  item.addEventListener('click', function() {
   	 necklace_length_input.value = item.innerText;
      variant_options.forEach(item2 => {
        item2.classList.remove('selected')
      })
     item.classList.add('selected')
  }) 
})

function toggleGiftPopup() {
   if ($(".overlay").hasClass("is-on")) {
    $(".overlay").removeClass("is-on");
  } else {
    $(".overlay").addClass("is-on");
    document.documentElement.dispatchEvent(new CustomEvent('cart:close', {bubbles: true}));
  } 
}  


/*$('#gift-wrap').change(() => {
   if ($(".overlay").hasClass("is-on")) {
    $(".overlay").removeClass("is-on");
  } else {
    $(".overlay").addClass("is-on");
    document.documentElement.dispatchEvent(new CustomEvent('cart:close', {bubbles: true}));
  } 
})
*/

$('#close_giftwrap').on('click',() => {
  $(".overlay").removeClass("is-on");
  document.documentElement.dispatchEvent(new CustomEvent('cart:open', {bubbles: true}));  
})

$(document).on('click', '.Add_Gift_Wrap', async function (event) {
  event.preventDefault();
  const button = this;
  if (button.hasAttribute('disabled')) return;

  const explain = $('.GiftWrap__Explain');
  const note = $('.GiftWrap__Note');
  const error = $('.Giftwrap__error');

  const selected =
    $('.gift_wrap_checkbox:checkbox:checked').val() ||
    $('.giftwrap_select_option:checked').val();

  if (!explain.val().trim()) {
    error.show();
    explain.trigger('focus')[0]?.scrollIntoView({ block: 'center', behavior: 'smooth' });
    return;
  }
  error.hide();

  button.setAttribute('disabled', 'disabled');
  button.setAttribute('aria-busy', 'true');

  try {
    await GiftWrap.add({
      id: selected || GiftWrap.productId,
      quantity: $('.gift_wrap_quantity .QuantitySelector__CurrentQuantity').val() || 1,
      properties: { 'ברכה': note.val(), 'הנחיות': explain.val() }
    });
    closeGiftWrapPopup();
  } catch (err) {
    error.text(err.message || 'לא הצלחנו להוסיף את האריזה').show();
  } finally {
    button.removeAttribute('disabled');
    button.removeAttribute('aria-busy');
  }
});

$(".gift_wrap_checkbox:checkbox").on('change', function() {
  var $box = $(this);
  if ($box.is(":checked")) {
    var group = ".gift_wrap_checkbox:checkbox[name='" + $box.attr("name") + "']";
    $(group).prop("checked", false);
    $box.prop("checked", true);
  } else {
    $box.prop("checked", false);
  }
});




function closeSubmenu(el) {
  if (el.classList.contains('SubSub_close')) {
    const parent = document.querySelectorAll(".Collapsible__Button[aria-expanded=true]")
    const collapsible = parent[1].parentNode
    const inner = parent[1].nextElementSibling
    parent[1].setAttribute("aria-expanded", "false")
    collapsible.style.overflow = "hidden"
    inner.style.overflow = "hidden"
  } else {
      const parent = document.querySelector(".Collapsible__Button[aria-expanded=true]")
      const collapsible = parent.parentNode
      const inner = parent.nextElementSibling
      parent.setAttribute("aria-expanded", "false")
      collapsible.style.overflow = "hidden"
      inner.style.overflow = "hidden"
  }
}

window.addEventListener('load', function () {
  const pplr_c_button = document.querySelector('.pplr-c-button')
  const product_cnt = document.querySelector('.Product')
  
  if (pplr_c_button != null && product_cnt != null) {
    if (product_cnt.getAttribute('data-zepto-hebrew') == 'false') {
       pplr_c_button.addEventListener('click', () => {
        const pplr_texts = document.querySelectorAll('.pplr_text')
        pplr_texts.forEach(input => {
          input.addEventListener('change', () => {
            let str = input.value
            str = str.replace(/[^0-9a-zA-Z♡&.,"'\/+ -]+/g, '');
            input.value = str
          })
        })
      }) 
    }
  }
})

$( document ).ready(function() {

  $('.giftwrap_select_option').on('change', function(event) {
    const labelText = $(this).parent('label').text().trim();
    $('#popover-variant-dropdown-giftwrap-selected-value').text(labelText);
    $('#popover-variant-dropdown-giftwrap-selected-value').css('opacity', 1)
  })

  $('a.prod label').on('click', function (event) {
    event.preventDefault(); // Prevent the default behavior of the label
    window.location.href = $(this).parent().parent().attr('href');
    const input = $(this).attr('for'); // Get the associated input ID
    if (input) {
      $(`#${input}`).trigger('click'); // Trigger a click on the associated input
    }
  });
  
  var modelError = $('.error-model')
  var chkColor = $('.csbundle:checked').val()
  $('#colorBundle').val(chkColor)
  $('.bundcolor .cont').text(chkColor)


  $('.csbundle').click( function() {
      var id = $(this).data('sel')
      var parent = $(this).parents('.bundcolor')
      var ind = $(parent).find('span.cont')
      var data = $(this).val() 
      $(ind).text(data) 

      $(modelError).hide()
      $(this).removeClass('red')
      $('#colorBundle').val('')
      $('#modelBundle').val('')

       var index = $(`.Carousel__Cell[data-varimg="${data}"]`).data('media-position')
      
      /*var flkty = new Flickity('.Product__Slideshow');
      flkty.select( index - 1 );*/

      if ($(window).width() > 1008 ) {
          var el = $('.Product__Slideshow').find(`[data-varimg=${data}]`)
          if (el.length) {
              $('html, body').animate({
                  scrollTop: $(el).offset().top
              }, 500);
          }

      }


      // $('.Product__Gallery').hide()
      $('.selecTor').hide()
      $(`.selecTor[data-sel="${id}"]`).show()
      parent.find('.ProductForm__Label').removeClass('red')

      $(`.selecTor[data-sel="${id}"]`).find('.bund-sel option').show()

      var prodID = $(`.selecTor[data-sel="${id}"]`).find('.bund-sel option:selected').data('productid')
      var varId = $(`.selecTor[data-sel="${id}"]`).find('.bund-sel option:selected').data('var')
      var varName = $(`.selecTor[data-sel="${id}"]`).find('.bund-sel option:selected').text()

      
      $("#selItems").val(varName + ' - ' +  data)
      $('#colorBundle').val(prodID)
      $('#modelBundle').val(varId)

      // $(`.Product__Gallery[data-sel="${id}"]`).show()

      if ( !$('#colorBundle').val() == "" ) {
          $('.bundcolor span.ProductForm__Label').removeClass('red')
          $('.bundle-add').removeAttr('disabled')
      }
      // var $carousel = $('.Product__Slideshow')
      // $carousel.flickity('resize')
  })

    if ($('.bund-sel option:checked').length > 0 ) {
        var activeColor = $('.csbundle:checked').data('sel')
        var activeColorName = $('.csbundle:checked').val()
        var index = $(this).parents('.selecTor')
        var index = $(index).data('sel')
        var modelValue = $(`.selecTor[data-sel="${activeColor}"]`).find('.bund-sel option:checked')
        var inActives = $('.selecTor').not(`.selecTor[data-sel="${activeColor}"]`)
        var unCheckeds = $(inActives).find('.bund-sel option:checked')

        var varName = $(`.selecTor[data-sel="${activeColor}"]`).find('.bund-sel option:selected').text()
            
        $(unCheckeds).attr('checked', false)
        $('.bund-sel option:checked').attr('checked', false)
        $('#modelBundle').val($(modelValue).data('var'))
        
        $("#selItems").val(varName + ' - ' + activeColorName)
    }
    $('.bund-sel').on('change', function() {
        var prodID = $(this).find(":selected").data('productid')
        var id = $(this).find(":selected").data('var')
        var parent = $(this).parents('.bundmodel')
        var data = $(this).val()
        var colorName = $('.csbundle:checked').val()

        $('#colorBundle').val('')
        $('#modelBundle').val('')

        $("#selItems").val(data + ' - ' +  colorName)
        $('#colorBundle').val(prodID)
        $('#modelBundle').val(id)

        if ( !$('#modelBundle').val() == "" ) {
            $(modelError).hide()
            $('.bundle-add').removeAttr('disabled')
        }

        if ($(this).val() != "") {
            $(this).parents('.selecTor').addClass('right-arr')
        } else {
            $(this).parents('.selecTor').removeClass('right-arr')
        }
        if ( data == null ) {
            modelError.show()   
            // $('.bundcolor .ProductForm__Label').addClass('red')
            $(this).find('option').show()
            $(this).addClass('red')
            $(this).parents('.selecTor').addClass('redded')
        } else {
            modelError.hide()
            $(this).find('option').show()
            $(this).removeClass('red')
            $(this).parents('.selecTor').removeClass('redded')
        }
    })
    

    var csinput = $('input[data-sel="0"]:checked')
    
    if ( $('input[data-sel="0"]:checked').length > 0 ) {
        $('.selecTor[data-sel="0"]').show()
    }

    var csbundle = $('.csbundle:checked').data('sel')
    $(`.selecTor[data-sel="${csbundle}"]`).show()

    $('select.filt-sel').on('change', function() {
        $(this).parents('.filt-wrapper').addClass('right-arr')
        window.location.href = $(this).val()
    })
    
    $('.selecTor').on('change', function() {
		$('.ProductForm__AddToCart').removeClass('Button--secondary')
        $('.ProductForm__AddToCart').addClass('Button--primary')
        $('.ProductForm__AddToCart').text('הוסיפי לסל')
    })
});

const GiftWrap = {
  productId: 8020638957801,

  bundledSections() {
    const sections = [];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections } })
    );
    return sections.join(',');
  },

  publish(cart, baseEvent) {
    if (window.themeVariables?.settings?.pageType === 'cart') {
      return window.location.reload();
    }
    if (!cart.sections) {
      return document.dispatchEvent(new CustomEvent('cart:refresh'));
    }
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent, cart } })
    );
  },

  async add({ id, quantity = 1, properties = {} }) {
    const sections = this.bundledSections();
    document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));
    try {
      const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: [{ id, quantity, properties }], sections })
      });
      const json = await response.json();
      if (!response.ok) throw new Error(json.description || json.message);

      const cart = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
      cart.sections = json.sections;
      this.publish(cart, 'variant:add');   // baseEvent 'variant:add' => drawer reopens
      return cart;
    } finally {
      document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
    }
  },

  async remove(lineKey) {
    const sections = this.bundledSections();
    document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));
    try {
      const response = await fetch(`${Shopify.routes.root}cart/change.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: lineKey, quantity: 0, sections })
      });
      const cart = await response.json();
      if (!response.ok) throw new Error(cart.description || cart.message);
      this.publish(cart, 'line-item:change');  // no auto-reopen on removal
      return cart;
    } finally {
      document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
    }
  }
};

class GiftWrapToggle extends HTMLElement {
  #abortController;

  connectedCallback() {
    this.#abortController = new AbortController();
    this.querySelector('button')?.addEventListener('click', this.#onClick.bind(this), {
      signal: this.#abortController.signal
    });
  }

  disconnectedCallback() { this.#abortController?.abort(); }

  get isAdded() { return this.hasAttribute('added'); }
  get lineKey() { return this.getAttribute('line-key'); }

  async #onClick(event) {
    const button = event.currentTarget;
    if (button.getAttribute('aria-busy') === 'true') return;

    if (!this.isAdded) return openGiftWrapPopup(button);

    button.setAttribute('aria-busy', 'true');
    try {
      await GiftWrap.remove(this.lineKey);
      // drawer re-renders; this element is replaced
    } catch (error) {
      button.removeAttribute('aria-busy');
      const box = this.querySelector('.gift-wrap__error');
      box.textContent = error.message || 'משהו השתבש, נסי שוב';
      box.hidden = false;
    }
  }
}
if (!window.customElements.get('gift-wrap-toggle')) {
  window.customElements.define('gift-wrap-toggle', GiftWrapToggle);
}


let giftWrapReturnFocus = null;
let giftWrapTrapPaused = false;
let giftWrapLockedByUs = false;

const cartDrawerEl = () => document.querySelector('cart-drawer');

function openGiftWrapPopup(trigger) {
  const overlay = document.querySelector('.overlay');
  if (!overlay || overlay.classList.contains('is-on')) return;

  giftWrapReturnFocus = trigger || document.activeElement;

  const drawer = cartDrawerEl();
  if (drawer?.open) {
    // onDeactivate no-op => trap releases WITHOUT calling drawer.hide()
    drawer.focusTrap.deactivate({ onDeactivate: () => {}, returnFocus: false });
    giftWrapTrapPaused = true;
    // drawer already applied `lock`, leave it alone
  } else {
    document.documentElement.classList.add('lock');
    giftWrapLockedByUs = true;
  }

  overlay.classList.add('is-on');
  document.addEventListener('keydown', onGiftWrapKeydown);
  requestAnimationFrame(() => overlay.querySelector('.GiftWrap__Note')?.focus());
}

function closeGiftWrapPopup() {
  document.querySelector('.overlay')?.classList.remove('is-on');
  document.removeEventListener('keydown', onGiftWrapKeydown);

  const drawer = cartDrawerEl();

  // Never strip `lock` if the drawer owns it — it keeps its own layer counter
  if (giftWrapLockedByUs && !drawer?.open) {
    document.documentElement.classList.remove('lock');
  }
  giftWrapLockedByUs = false;

  if (giftWrapTrapPaused) {
    giftWrapTrapPaused = false;
    if (drawer?.open) drawer.focusTrap.activate();
  }

  giftWrapReturnFocus?.focus();
  giftWrapReturnFocus = null;
}

function onGiftWrapKeydown(event) {
  if (event.key === 'Escape') closeGiftWrapPopup();
}

function toggleGiftPopup() {
  document.querySelector('.overlay')?.classList.contains('is-on')
    ? closeGiftWrapPopup()
    : openGiftWrapPopup();
}

(() => {
  const DEFER_CLASS = 'product-card-gallery__img--defer';

  // Strip src/srcset before the browser fetches them, stash on the element
  const park = (img) => {
    if (img.dataset.pcgParked) return;
    img.dataset.pcgParked = '1';
    img.dataset.pcgSrc = img.getAttribute('src') || '';
    img.dataset.pcgSrcset = img.getAttribute('srcset') || '';
    img.removeAttribute('src');
    img.removeAttribute('srcset');
  };

  const restore = (img) => {
    if (!img.dataset.pcgParked) return;
    if (img.dataset.pcgSrcset) img.setAttribute('srcset', img.dataset.pcgSrcset);
    if (img.dataset.pcgSrc) img.setAttribute('src', img.dataset.pcgSrc);
    img.classList.remove(DEFER_CLASS);
    ['pcgParked', 'pcgSrc', 'pcgSrcset'].forEach((k) => delete img.dataset[k]);
  };

  const parkAll = (root = document) =>
    root.querySelectorAll(`.${DEFER_CLASS}`).forEach(park);

  const hydrate = (gallery) => {
    if (!gallery || gallery.dataset.pcgHydrated) return;
    gallery.dataset.pcgHydrated = '1';
    gallery.querySelectorAll(`.${DEFER_CLASS}`).forEach(restore);
  };

  const onIntent = (event) => {
    const gallery = event.target.closest?.('.product-card-gallery');
    if (gallery) hydrate(gallery);
  };

  parkAll();
  document.addEventListener('pointerenter', onIntent, { capture: true });
  document.addEventListener('touchstart', onIntent, { capture: true, passive: true });
  document.addEventListener('focusin', onIntent);

  // Re-park after collection filtering / cart re-renders replace section markup
  new MutationObserver((records) => {
    records.forEach((record) => {
      record.addedNodes.forEach((node) => {
        if (node.nodeType === 1) parkAll(node);
      });
    });
  }).observe(document.body, { childList: true, subtree: true });
})();